import { Text } from 'foundations-components/components/Text';
import { Badge } from 'foundations-components/transitional/components/Badge';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const BadgeLabel = ({
  use,
  seleniumId,
  children
}) => /*#__PURE__*/_jsx(Badge, {
  use: use,
  alignSelf: "center",
  marginInlineStart: "-100",
  children: /*#__PURE__*/_jsx(Text, {
    as: "span",
    typography: "heading-25",
    textWrap: "nowrap",
    "data-selenium-id": seleniumId,
    children: children
  })
});
export const HsocMerchCardBadge = ({
  badge
}) => {
  if (badge.type === 'recommended') {
    return /*#__PURE__*/_jsx(BadgeLabel, {
      use: "sorbet",
      seleniumId: "hsoc-recommended-badge",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hsocPricingPage.badge.recommended"
      })
    });
  }
  if (badge.type === 'currentPlan') {
    return /*#__PURE__*/_jsx(BadgeLabel, {
      use: "koala",
      seleniumId: "hsoc-current-plan-badge",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hsocPricingPage.badge.current"
      })
    });
  }
  if (badge.type === 'limitedTimeOffer') {
    return /*#__PURE__*/_jsx(BadgeLabel, {
      use: "red",
      seleniumId: "hsoc-limited-time-offer-badge",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hsocPricingPage.badge.limitedTimeOffer",
        options: {
          discount: badge.discountPercentage
        }
      })
    });
  }
  return null;
};